export default "/fonts/Acrom-Regular.ttf?2be67058e6c124ea5130faf380fa765d";